export const objectUtil = {
    nullToDefault(checkValue, defaultValue) {
        if (checkValue === undefined || checkValue === null) {
            return defaultValue;
        }
        return checkValue
    }
}